import { render, staticRenderFns } from "./Districts.vue?vue&type=template&id=0707c04f&"
import script from "./Districts.vue?vue&type=script&lang=js&"
export * from "./Districts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports